export default "__VITE_ASSET__wa9_NHrv__"